import React from 'react';
import { WatchRender } from './WatchRender';
import { Logo } from './Logo';
import type { Product } from '../types/shop';
type ProductVisualProps = {
  product: Product;
  className?: string;
  imgClassName?: string;
};
export function ProductVisual({
  product,
  className = '',
  imgClassName = ''
}: ProductVisualProps) {
  if (product.visual === 'watch') {
    return <div className={`grid place-items-center ${product.backdrop} ${className}`} data-id="element-365" data-mp="o1cl2rrxmjdi">
        <WatchRender face="cream" className="w-[46%]" data-id="element-366" data-mp="o3fk21b2bmud" />
      </div>;
  }
  if (product.visual === 'gift-card') {
    return <div className={`grid place-items-center ${product.backdrop} ${className}`} role="img" aria-label={product.imageAlt} data-id="element-367" data-mp="f9kguyti46hd">
        <div className="flex aspect-[1.6] w-[66%] flex-col justify-between bg-charcoal p-[6%] shadow-[0_30px_50px_-30px_rgba(30,30,30,0.6)]" data-id="element-368" data-mp="j9kvokkiijoy">
          <Logo tone="light" data-id="element-369" data-mp="16ydt6lgs8zlo" />
          <div className="flex items-end justify-between" data-id="element-370" data-mp="1brgq93krqr6m">
            <span className="t-label text-[0.6rem] text-cream/80" data-id="element-371" data-mp="1bt1mcxmqei6l">Gift Card</span>
            <span className="t-numeral text-sm text-gold" data-id="element-372" data-mp="24cvykkfly64w">XII</span>
          </div>
        </div>
      </div>;
  }
  return <div className={`overflow-hidden ${product.backdrop} ${className}`} data-id="element-373" data-mp="1zbf2r3bzd9v6">
      <img src={product.image} alt={product.imageAlt} loading="lazy" className={`h-full w-full object-cover ${imgClassName}`} data-id="element-374" data-mp="2e3gws6rdd8na" />
    </div>;
}